import React, { useMemo, useCallback } from 'react';
import { IoLogoWhatsapp } from "react-icons/io5";
import { FaPlus, FaSave, FaTimes, FaClipboardList } from "react-icons/fa";
import "./OrderModalOne.css";

const CURRENT_YEAR = new Date().getFullYear();
const YEARS = Array.from({ length: CURRENT_YEAR - 1979 }, (_, i) => CURRENT_YEAR - i);

const ServiceItem = React.memo(({ serv, index, onChange, onRemove }) => (
    <div className="o-new-service-item">
        <input
            placeholder="Descrição do serviço"
            value={serv.Service}
            onChange={e => onChange(index, 'Service', e.target.value)}
        />
        <input
            type="number"
            placeholder="Valor (R$)"
            value={serv.valor}
            onChange={e => onChange(index, 'valor', e.target.value)}
        />
        <button
            className="o-remove-service-btn"
            type="button"
            onClick={() => onRemove(index)}
            title="Remover serviço"
        >
            <FaTimes />
        </button>
    </div>
));

const OrderModal = ({
    isOpen,
    onClose,
    newOrder,
    setNewOrder,
    brands,
    models,
    clientSuggestions,
    vehicleSuggestions,
    handleClientChange,
    selectClient,
    handlePlateChange,
    selectVehicle,
    fetchModels,
    handleChange,
    handleAddService,
    handleRemoveService,
    handleServiceChange,
    handleAddOrder
}) => {

    const total = useMemo(() =>
        newOrder.serviceDescription
            .reduce((acc, s) => acc + (parseFloat(String(s.valor).replace(',', '.')) || 0), 0)
            .toLocaleString('pt-BR', { minimumFractionDigits: 2 }),
        [newOrder.serviceDescription]
    );

    const handleBrandChange = useCallback((e) => {
        const brandId = e.target.value;
        setNewOrder(prev => ({ ...prev, brand: brandId, model: '' }));
        fetchModels(brandId);
    }, [setNewOrder, fetchModels]);

    const handleWhatsappChange = useCallback((e) => {
        setNewOrder(prev => ({ ...prev, isWhatsapp: e.target.checked }));
    }, [setNewOrder]);

    if (!isOpen) return null;


    return (
        <div className="o-modal-overlay" onClick={e => e.target === e.currentTarget && onClose()}>
            <div className="o-modal">

                {/* ── Header ── */}
                <div className="o-modal-header">
                    <div className="o-modal-header-left">
                        <div className="o-modal-header-icon">
                            <FaClipboardList />
                        </div>
                        <div>
                            <p className="o-modal-title">Nova Ordem de Serviço</p>
                            <p className="o-modal-subtitle">Preencha os dados abaixo</p>
                        </div>
                    </div>
                    <span className="o-modal-total-badge">R$ {total}</span>
                </div>

                {/* ── Body — duas colunas ── */}
                <div className="o-modal-body">

                    {/* Coluna esquerda */}
                    <div className="o-col-left">

                        {/* Cliente */}
                        <div className="o-section">
                            <span className="o-section-label">Cliente</span>
                            <div className="o-autocomplete-wrap">
                                <input
                                    type="text"
                                    placeholder="Nome do cliente"
                                    value={newOrder.cliente}
                                    onChange={e => handleClientChange(e.target.value)}
                                />
                                {clientSuggestions.length > 0 && (
                                    <ul className="autocomplete-list">
                                        {clientSuggestions.map(c => (
                                            <li key={c.id} onClick={() => selectClient(c)}>
                                                {c.name} — {c.phone}
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </div>
                            <input
                                name="projectName"
                                placeholder="Nome fantasia (opcional)"
                                value={newOrder.projectName}
                                onChange={handleChange}
                            />
                            <input
                                name="email"
                                placeholder="E-mail"
                                value={newOrder.email}
                                onChange={handleChange}
                            />
                            <div className="o-phone-whatsapp">
                                <input
                                    name="phone"
                                    placeholder="Telefone"
                                    value={newOrder.phone}
                                    onChange={handleChange}
                                />
                                <label className="o-whatsapp-toggle" title="É WhatsApp?">
                                    <input
                                        type="checkbox"
                                        checked={newOrder.isWhatsapp}
                                        onChange={handleWhatsappChange}
                                    />
                                    <IoLogoWhatsapp />
                                </label>
                            </div>
                        </div>

                        {/* Veículo */}
                        <div className="o-section">
                            <span className="o-section-label">Veículo</span>
                            <div className="o-autocomplete-wrap">
                                <input
                                    type="text"
                                    placeholder="Placa"
                                    value={newOrder.plate}
                                    onChange={e => handlePlateChange(e.target.value)}
                                    className="o-input-plate"
                                />
                                {vehicleSuggestions.length > 0 && (
                                    <ul className="autocomplete-list">
                                        {vehicleSuggestions.map(v => (
                                            <li key={v.id} onClick={() => selectVehicle(v)}>
                                                {v.plate} — {v.brand} {v.model}
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </div>
                            <select value={newOrder.brand} onChange={handleBrandChange}>
                                <option value="">Marca</option>
                                {brands.map(b => (
                                    <option key={b.id} value={b.id}>{b.name}</option>
                                ))}
                            </select>
                            <select
                                name="model"
                                value={newOrder.model}
                                onChange={handleChange}
                                disabled={!models.length}
                            >
                                <option value="">Modelo</option>
                                {models.map(m => (
                                    <option key={m.id} value={m.id}>{m.description}</option>
                                ))}
                            </select>
                            <div className="o-vehicle-row">
                                <select name="year" value={newOrder.year} onChange={handleChange}>
                                    <option value="">Ano</option>
                                    {YEARS.map(y => (
                                        <option key={y} value={y}>{y}</option>
                                    ))}
                                </select>
                                <select name="vehicleType" value={newOrder.vehicleType} onChange={handleChange}>
                                    <option value="">Tipo</option>
                                    <option value="veiculo">Veículo</option>
                                    <option value="semi">Semi-Reboque</option>
                                </select>
                            </div>
                            <input
                                name="vehicleDescription"
                                placeholder="Descrição adicional"
                                value={newOrder.vehicleDescription}
                                onChange={handleChange}
                            />
                        </div>

                    </div>{/* fim o-col-left */}

                    {/* Coluna direita — serviços */}
                    <div className="o-col-right">
                        <div className="o-services-header">
                            <span className="o-section-label">Serviços Prestados</span>
                            <button className="o-add-service-btn" type="button" onClick={handleAddService}>
                                <FaPlus /> Adicionar
                            </button>
                        </div>

                        <div className="o-services-scroll">
                            <div className="o-services-list">
                                {newOrder.serviceDescription.length === 0 ? (
                                    <p className="o-services-empty">Nenhum serviço adicionado ainda.</p>
                                ) : (
                                    newOrder.serviceDescription.map((serv, i) => (
                                        <ServiceItem
                                            key={i}
                                            index={i}
                                            serv={serv}
                                            onChange={handleServiceChange}
                                            onRemove={handleRemoveService}
                                        />
                                    ))
                                )}
                            </div>
                        </div>

                        {newOrder.serviceDescription.length > 0 && (
                            <div className="o-services-total">
                                <span className="o-services-total-label">Total estimado</span>
                                <span className="o-services-total-val">R$ {total}</span>
                            </div>
                        )}
                    </div>

                </div>{/* fim o-modal-body */}

                {/* ── Footer ── */}
                <div className="o-modal-footer">
                    <button className="o-btn-cancel" type="button" onClick={onClose}>
                        Cancelar
                    </button>
                    <button className="o-btn-save" type="button" onClick={handleAddOrder}>
                        <FaSave /> Salvar Ordem
                    </button>
                </div>

            </div>
        </div>
    );
};

export default OrderModal;